import { create } from 'zustand';
import type { ReportInputStore, ReportsUserInput } from '../types/reports';
import { initialReportsUserInput } from '../utils/analyticsUserInput';

export const useReportInputStore = create<ReportInputStore>()((set, get) => ({
  ...initialReportsUserInput,

  setDatasetSW: (datasetSW: string | null) => set({ datasetSW }),
  setDatasetHD: (datasetHD: string | null) => set({ datasetHD }),
  setDatasetWind: (datasetWind: string | null) => set({ datasetWind }),
  setTimeStep: (timeStep: string) => set({ timeStep }),
  setStartDate: (startDate: moment.Moment) => set({ startDate }),
  setEndDate: (endDate: moment.Moment) => set({ endDate }),

  setReportInput: (input: ReportsUserInput) => set(input),

  requestedReportsCount: 0,
  setRequestedReportsCount: () =>
    set((state) => ({
      requestedReportsCount: state.requestedReportsCount + 1,
    })),
}));
